module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xU4aKs/tc-custom/9781452165585.jpg?1721442252542",
      "alt": "This image is the cover for the book City Walks: San Francisco, City Walks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("City Walks: San Francisco, City Walks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The revised and updated third edition of the classic walking guide to San Francisco.")]), _c('br'), _c('br'), _vm._v("This list of walking tours in San Francisco features brand new neighborhoods, restaurants, shops, and landmarks. Perfect for tourists exploring in the Bay Area, recent transplants, or even locals who want to become familiar with a new part of the city, this ebook shares the hidden gems of San Francisco. "), _c('br'), _c('br'), _vm._v("Each walk, from The Presidio to Japantown to the Embarcadero and the Exploratorium, is detailed with a full-color map, walking directions, and highlighted stopping points.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Henry de Tessan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0